import '../modules/userNav'
import '../modules/hamburger'
import toastr from 'toastr'
import Swal from 'sweetalert2'
window.toastr = toastr
window.Swal = Swal